import { IValidateNationalTokenRequest, ValidateNationalToken } from '../contracts';
import axios from 'axios';
import { createAxiosConfig } from '../mockHelper';

export const ValidateNationalTokenApi = (endpoint: string): ValidateNationalToken =>
  async ({ zipCode, token }: IValidateNationalTokenRequest) => {
    try {
      let queryString = `?zipCode=${zipCode}&${token}`;
      const constructedEndpoint = `${endpoint}/${queryString}`;
      const response = await axios.get(constructedEndpoint, createAxiosConfig(null, endpoint));

      return Promise.resolve(response?.data);
    } catch (e) {
      return Promise.reject({error: e});
    }
}